"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.ReferralsIncentivesRegisterSuccessAnalyticsEvent = exports.ReferralsIncentivesRegisterErrorAnalyticsEvent = exports.ReferralsFaqLinkClickedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when user is successfully registered to the referrer's incentives program
 */
var ReferralsIncentivesRegisterSuccessAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('referrals_incentives_register_success');
exports.ReferralsIncentivesRegisterSuccessAnalyticsEvent = ReferralsIncentivesRegisterSuccessAnalyticsEvent;
/**
 * Triggers when user fails to register to the referrer's incentives program
 */
var ReferralsIncentivesRegisterErrorAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('referrals_incentives_register_error');
exports.ReferralsIncentivesRegisterErrorAnalyticsEvent = ReferralsIncentivesRegisterErrorAnalyticsEvent;
/**
 * Triggers when user clicks the referrals FAQ CTA
 */
var ReferralsFaqLinkClickedAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('referrals_faq_link_clicked');
exports.ReferralsFaqLinkClickedAnalyticsEvent = ReferralsFaqLinkClickedAnalyticsEvent;
